import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useMe } from "@/hooks/useMe";
import { useApi, euro } from "@/lib/api";
import { ProductsTab } from "@/components/admin/ProductsTab";
import { OrdersTab } from "@/components/admin/OrdersTab";
import { UsersTab } from "@/components/admin/UsersTab";
import { SyncTab } from "@/components/admin/SyncTab";
import { SlidesTab } from "@/components/admin/SlidesTab";
import { OutletTab } from "@/components/admin/OutletTab";
import { PhotosTab } from "@/components/admin/PhotosTab";
import { PricesTab } from "@/components/admin/PricesTab";

const Stats = () => {
  const call = useApi();
  const [s, setS] = useState(null);
  useEffect(() => { call("get", "/admin/stats").then((r) => setS(r.data)); }, [call]);
  const cards = s ? [
    ["Ventas totales", euro(s.total_sales), "stat-sales"],
    ["Pedidos pagados", s.orders_paid, "stat-orders"],
    ["Pedidos activos", s.orders_active, "stat-active"],
    ["Productos", s.products, "stat-products"],
    ["Stock bajo", s.low_stock, "stat-lowstock"],
    ["Avisos de talla", s.alerts_pending, "stat-alerts"],
  ] : [];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-6 gap-4 mt-8">
      {cards.map(([l, v, id]) => (
        <div key={id} className="bg-white border p-5">
          <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-slate-500">{l}</p>
          <p className="mt-2 font-heading text-3xl font-black" data-testid={id}>{v}</p>
        </div>
      ))}
    </div>
  );
};

export default function Admin() {
  const { me, loading, isSignedIn } = useMe();
  if (loading) return <div className="py-32 text-center text-slate-500">Cargando…</div>;
  if (!isSignedIn) return <Navigate to="/sign-in" replace />;
  if (me?.role !== "admin") return <div className="py-32 text-center" data-testid="admin-forbidden">No tienes acceso al panel de administración.</div>;

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-14" data-testid="admin-page">
      <p className="eyebrow">Panel</p>
      <h1 className="mt-2 font-heading text-4xl sm:text-5xl font-black uppercase tracking-tight">Administración</h1>
      <Stats />
      <Tabs defaultValue="products" className="mt-10">
        <TabsList>
          <TabsTrigger value="products" data-testid="admin-tab-products">Productos</TabsTrigger>
          <TabsTrigger value="prices" data-testid="admin-tab-prices">Stock y precios</TabsTrigger>
          <TabsTrigger value="orders" data-testid="admin-tab-orders">Pedidos</TabsTrigger>
          <TabsTrigger value="users" data-testid="admin-tab-users">Usuarios</TabsTrigger>
          <TabsTrigger value="outlet" data-testid="admin-tab-outlet">Outlet</TabsTrigger>
          <TabsTrigger value="photos" data-testid="admin-tab-photos">Fotos</TabsTrigger>
          <TabsTrigger value="slides" data-testid="admin-tab-slides">Slides</TabsTrigger>
          <TabsTrigger value="sync" data-testid="admin-tab-sync">ClassicGes</TabsTrigger>
        </TabsList>
        <TabsContent value="outlet" className="mt-6"><OutletTab /></TabsContent>
        <TabsContent value="photos" className="mt-6"><PhotosTab /></TabsContent>
        <TabsContent value="products" className="mt-6"><ProductsTab /></TabsContent>
        <TabsContent value="prices" className="mt-6"><PricesTab /></TabsContent>
        <TabsContent value="orders" className="mt-6"><OrdersTab /></TabsContent>
        <TabsContent value="users" className="mt-6"><UsersTab /></TabsContent>
        <TabsContent value="slides" className="mt-6"><SlidesTab /></TabsContent>
        <TabsContent value="sync" className="mt-6"><SyncTab /></TabsContent>
      </Tabs>
    </div>
  );
}
